function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.33594 4.66732C3.15913 4.66732 2.98956 4.73756 2.86453 4.86258C2.73951 4.9876 2.66927 5.15717 2.66927 5.33398V12.6673C2.66927 12.8441 2.73951 13.0137 2.86453 13.1387C2.98956 13.2637 3.15913 13.334 3.33594 13.334H10.6693C10.8461 13.334 11.0157 13.2637 11.1407 13.1387C11.2657 13.0137 11.3359 12.8441 11.3359 12.6673V8.66732C11.3359 8.29913 11.6344 8.00065 12.0026 8.00065C12.3708 8.00065 12.6693 8.29913 12.6693 8.66732V12.6673C12.6693 13.1978 12.4586 13.7065 12.0835 14.0815C11.7084 14.4566 11.1997 14.6673 10.6693 14.6673H3.33594C2.8055 14.6673 2.2968 14.4566 1.92172 14.0815C1.54665 13.7065 1.33594 13.1978 1.33594 12.6673V5.33398C1.33594 4.80355 1.54665 4.29484 1.92172 3.91977C2.2968 3.5447 2.8055 3.33398 3.33594 3.33398H7.33594C7.70413 3.33398 8.0026 3.63246 8.0026 4.00065C8.0026 4.36884 7.70413 4.66732 7.33594 4.66732H3.33594Z",
  fill: "#77716C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.33594 2.00065C9.33594 1.63246 9.63441 1.33398 10.0026 1.33398H14.0026C14.3708 1.33398 14.6693 1.63246 14.6693 2.00065V6.00065C14.6693 6.36884 14.3708 6.66732 14.0026 6.66732C13.6344 6.66732 13.3359 6.36884 13.3359 6.00065V2.66732H10.0026C9.63441 2.66732 9.33594 2.36884 9.33594 2.00065Z",
  fill: "#77716C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.474 1.52925C14.7344 1.7896 14.7344 2.21171 14.474 2.47206L7.14068 9.80539C6.88033 10.0657 6.45822 10.0657 6.19787 9.80539C5.93752 9.54504 5.93752 9.12293 6.19787 8.86258L13.5312 1.52925C13.7915 1.2689 14.2137 1.2689 14.474 1.52925Z",
  fill: "#77716C"
});

function SvgOpenInNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open-in-new.3907f053.svg";
export { ForwardRef as ReactComponent };